import React from 'react';
import { translate } from 'react-i18next';
import Actions from 'depreciations/components/list/DepreciationsActions';

const DepreciationsListRow = ({
  depreciation,
  company,
  subcompany,
  permissions,
  t,
  handleToggle,
}) => {
  return (
    <tr>
      <td>{depreciation.key}</td>
      <td>{depreciation.name}</td>
      <td className="text-center">{t(depreciation.active ? 'common.yes' : 'common.no')}</td>
      <td className="text-center">
        <Actions
          permissions={permissions}
          depreciation={depreciation}
          company={company}
          subcompany={subcompany}
          handleToggle={handleToggle}
        />
      </td>
    </tr>
  );
};

export default translate()(DepreciationsListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/list/DepreciationsListRow.js